import { render, staticRenderFns } from "./main-test.vue?vue&type=template&id=5b4ff7fe"
import script from "./main-test.vue?vue&type=script&lang=js"
export * from "./main-test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports